module.exports = __webpack_public_path__ + "img/active-item-bgimg.8d09c947.png";